module.exports = __webpack_public_path__ + "img/BlinkArt_Sword14_Red.e3c75550.png";